// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__gSHqd","fileBtn":"File_fileBtn__ilEXt","closeBtn":"File_closeBtn__z5Lo1","fileSelected":"File_fileSelected__2a3pC","disabled":"File_disabled__22NbR"};